import AppLayout from "../layouts/AppLayout";
import "./css/Home.css";

const Home = () => {
  return (
    <AppLayout>
      <div className="home-hero">
        <div className="home-card">

          {/* Closed banner */}
          <div className="closed-banner">
            <div className="closed-dot" />
            <p>This project is no longer active. nuChat has been shut down.</p>
          </div>

          <h1>
            Share notes, links & code safely on{" "}
            <span className="highlight">shared lab PCs</span>
          </h1>
          <p className="tagline">
            No email. No phone number.
            <br />
            Just a username and instant access.
          </p>
          <ul className="trust-points">
            <li>🔒 Built for university lab computers</li>
            <li>📱 Optional login for personal devices only</li>
            <li>🗑️ Sessions clear instantly on logout</li>
            <li>
              💬 Public messages auto-clear <strong>after 1 hour</strong>
            </li>
          </ul>
          <div className="actions">
            <button className="btn primary-btn" disabled>
              Enter nuChat
            </button>
            <p className="secondary-action">
              Registration and login are no longer available.
            </p>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default Home;
